exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nh1[data-v-686f7c9c], h2[data-v-686f7c9c] {\n    font-weight: normal;\n}\nul[data-v-686f7c9c] {\n    list-style-type: none;\n    padding: 0;\n}\nli[data-v-686f7c9c] {\n    display: inline-block;\n    margin: 0 10px;\n}\na[data-v-686f7c9c] {\n    color: #42b983;\n}\n.btn-lg[data-v-686f7c9c] {\n    width: 100%;\n}\n", ""]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-686f7c9c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/User/Signup.vue
// module id = TdZ1
// module chunks = 1